'use client';
import { jsx } from 'react/jsx-runtime';
import { AnimatePresence } from 'framer-motion';
import { DialogContextProvider, DialogStylesProvider } from './dialog-context.mjs';
import { useDialog } from './use-dialog.mjs';
import { Portal } from '../portal/portal.mjs';
import { useMultiStyleConfig } from '../system/use-style-config.mjs';

const DialogRoot = (props) => {
  const modalProps = {
    scrollBehavior: "outside",
    autoFocus: true,
    trapFocus: true,
    returnFocusOnClose: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    preserveScrollBarGap: true,
    motionPreset: "scale",
    lockFocusAcrossFrames: true,
    ...props
  };
  const {
    portalProps,
    children,
    autoFocus,
    trapFocus,
    initialFocusRef,
    finalFocusRef,
    returnFocusOnClose,
    blockScrollOnMount,
    allowPinchZoom,
    preserveScrollBarGap,
    motionPreset,
    lockFocusAcrossFrames,
    onCloseComplete
  } = modalProps;
  const styles = useMultiStyleConfig("Modal", modalProps);
  const api = useDialog(modalProps);
  const context = {
    ...api,
    autoFocus,
    trapFocus,
    initialFocusRef,
    finalFocusRef,
    returnFocusOnClose,
    blockScrollOnMount,
    allowPinchZoom,
    preserveScrollBarGap,
    motionPreset,
    lockFocusAcrossFrames
  };
  return /* @__PURE__ */ jsx(DialogContextProvider, { value: context, children: /* @__PURE__ */ jsx(DialogStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(AnimatePresence, { onExitComplete: onCloseComplete, children: context.isOpen && /* @__PURE__ */ jsx(Portal, { ...portalProps, children }) }) }) });
};
DialogRoot.displayName = "Dialog";

export { DialogRoot };
